import { Injectable } from "@angular/core";
import { Subject } from 'rxjs';

const CHAT_URL = `ws://localhost:8282/`;

@Injectable({
    providedIn: 'root'
})
export class DocumentTemplateSocketService {

    private ws: WebSocket;
    private url: string = CHAT_URL;

    private incomingMessages = new Subject<any>();
    public messages$ = this.incomingMessages.asObservable();

    private reconnectDelay = 2000;
    private isConnecting = false;

    constructor() {
        this.setupWebSocket();
    }

    private setupWebSocket() {

        if (this.isConnecting) return;

        this.isConnecting = true;

        console.log('Creando WebSocket...');

        this.ws = new WebSocket(this.url);

        this.ws.onopen = () => {
            console.log('WS conectado');
            this.isConnecting = false;
        };

        this.ws.onmessage = (event: MessageEvent) => {
            try {
                const data = JSON.parse(event.data);
                this.incomingMessages.next(data);
            } catch (e) {
                console.error('Error parseando mensaje', e);
            }
        };

        this.ws.onerror = (err) => {
            console.error('WS error', err);
        };

        this.ws.onclose = () => {
            console.warn('WS cerrado → reconectando...');
            this.isConnecting = false;

            setTimeout(() => {
                this.setupWebSocket();
            }, this.reconnectDelay);
        };
    }

    public send(data: any) {

        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {

            console.warn('WS no abierto. Intentando reconectar...');

            this.setupWebSocket();

            const waitForOpen = setInterval(() => {
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                    clearInterval(waitForOpen);
                    console.log('Enviando (post-reconexión)');
                    this.ws.send(JSON.stringify(data));
                }
            }, 200);

            return;
        }
        console.log('Enviando mensaje');
        this.ws.send(JSON.stringify(data));
    }

    public close() {
        if (this.ws) {
            this.ws.close();
        }
    }
}